import React from 'react';
import { DefaultWidgetWithHeader } from '../../_lib/components/Widget';
import { ContextWidget } from '../../types/api/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { Icons } from '../../components/atoms/SVG';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { isEmptyBlock, isNonEmptyBlock } from '../../types/api/Block';
import { PagePropertySettingsBlock } from '../../_blocks/PagePropertySettings/PagePropertySettingsBlock';
import { DefaultAccordion } from '../../_lib/components/Accordion/DefaultAccordion';
import { NavigationPropertiesBlock } from '../../_blocks/NavigationProperties/NavigationProperties';
import { TeaserInformationBlock } from '../../_blocks/TeaserInformation/TeaserInformationBlock';
import { TransformPageTypeBlock } from '../../_blocks/TransformPageType/TransformPageTypeBlock';
import { mapContextBlock } from '../../_blocks/mapContextBlock';

type PageSettingsBlocks =
  PagePropertySettingsBlock | NavigationPropertiesBlock | TeaserInformationBlock | TransformPageTypeBlock;
export type PageSettingsWidget = ContextWidget<PageSettingsBlocks, WidgetType.pagesettings>;

export function PageSettingsWidget({ blocks, elementType, ...headerProps }: PageSettingsWidget) {
  const { t } = useSonTranslation('PageSettings');

  if (blocks.every(isEmptyBlock)) {
    return null;
  }
  const accordionData = blocks.filter(isNonEmptyBlock).map(block => ({
    key: block.uuid,
    id: `${block.elementType}-${block.uuid}`,
    category: t(block.elementType),
    props: block,
  }));

  return (
    <DefaultWidgetWithHeader {...headerProps} widgetType={elementType} icon={Icons.SETTINGS} title={t('widgetTitle')}>
      <DefaultAccordion data={accordionData}>{({ props }) => mapContextBlock(props)}</DefaultAccordion>
    </DefaultWidgetWithHeader>
  );
}
